import { render, staticRenderFns } from "./Escrivao.vue?vue&type=template&id=217527b9&scoped=true&"
import script from "./Escrivao.vue?vue&type=script&lang=js&"
export * from "./Escrivao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217527b9",
  null
  
)

export default component.exports